import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { StyledProgressBar } from "@/styles";
import { theme } from "@/theme";
import { getJobStatusConfigHandler, getProgressValueHandler } from "@/utils";

const JobStatus = ({ data }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const status = data?.status || "waiting";
    const progress = data?.progress ?? data?.result?.progress;
    const entityType = location.pathname.includes("release") ? t("releases.name") : t("tracks.name");

    const statusConfig = getJobStatusConfigHandler(theme, t, data, entityType);
    const config = statusConfig[status] || statusConfig.waiting;
    const IconComponent = config.icon;
    const progressValue = getProgressValueHandler(status, progress);

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.grey[100],
                borderRadius: 2,
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                p: 3,
                width: "70%",
            }}
        >
            <Box
                sx={{
                    alignItems: "center",
                    display: "flex",
                    gap: 2,
                    mb: 2,
                }}
            >
                <Box
                    sx={{
                        alignItems: "center",
                        backgroundColor: theme.palette.common.white,
                        borderRadius: "50%",
                        display: "flex",
                        height: 48,
                        justifyContent: "center",
                        width: 48,
                    }}
                >
                    <IconComponent
                        sx={{
                            color: config.iconColor,
                            fontSize: 28,
                        }}
                    />
                </Box>
                <Typography
                    variant="h6"
                    sx={{
                        color: theme.palette.grey[800],
                        fontWeight: 600,
                    }}
                >
                    {config.title}
                </Typography>
            </Box>
            <Box
                sx={{
                    alignItems: "center",
                    display: "flex",
                    gap: 2,
                    mb: 2,
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                    }}
                >
                    <StyledProgressBar
                        status={status}
                        value={progressValue}
                        variant={config.variant || "determinate"}
                    />
                </Box>
                <Typography
                    variant="body2"
                    sx={{
                        color: theme.palette.grey[700],
                        minWidth: 45,
                    }}
                >
                    {`${progressValue}%`}
                </Typography>
            </Box>
            <Typography
                variant="body2"
                sx={{
                    color: theme.palette.grey[700],
                    textAlign: "center",
                }}
            >
                {config.subtitle}
            </Typography>
        </Box>
    );
};

JobStatus.propTypes = {
    data: PropTypes.shape({
        progress: PropTypes.number,
        result: PropTypes.shape({
            progress: PropTypes.number,
        }),
        status: PropTypes.string,
    }),
};

export default JobStatus;
